"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseServices_1 = require("../base-services/BaseServices");
var __1 = require("..");
var ControllerBase = "guide";
var SizeGuideServices = /** @class */ (function () {
    function SizeGuideServices() {
    }
    SizeGuideServices.GetTypesSizeGuide = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                data = [];
                try {
                    // const userCred = StorageServices.GetCookieUserCredentials();
                    // data = await BaseServices.GetServices(ControllerBase, `products?userid=${userCred.UserId}&platformid=${userCred.PlatformId}`);
                    data = [
                        { Id: 1, Name: "Superiores" },
                        { Id: 2, Name: "Inferiores" },
                        { Id: 3, Name: "Enteras" },
                        { Id: 4, Name: "Sostenes" },
                        { Id: 5, Name: "Calzado" },
                    ];
                }
                catch (error) {
                    console.log(error);
                }
                return [2 /*return*/, data];
            });
        });
    };
    SizeGuideServices.GetSizesGuides = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, userCred, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = {};
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        userCred = __1.StorageServices.GetCookieUserCredentials();
                        return [4 /*yield*/, BaseServices_1.default.GetServices(ControllerBase, "guides?userid=".concat(userCred.UserId, "&platformid=").concat(userCred.PlatformId))];
                    case 2:
                        data = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, data];
                }
            });
        });
    };
    SizeGuideServices.GetSizeGuide = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var data, userCred, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = {};
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        userCred = __1.StorageServices.GetCookieUserCredentials();
                        return [4 /*yield*/, BaseServices_1.default.GetServices(ControllerBase, "guides/".concat(id, "?userid=").concat(userCred.UserId, "&platformid=").concat(userCred.PlatformId))];
                    case 2:
                        data = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        console.log(error_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, data];
                }
            });
        });
    };
    SizeGuideServices.PostSizeGuide = function (sizeGuide) {
        return __awaiter(this, void 0, void 0, function () {
            var data, params, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = {};
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        params = {
                            UserCred: __1.StorageServices.GetCookieUserCredentials(),
                            Content: sizeGuide,
                        };
                        return [4 /*yield*/, BaseServices_1.default.PostServices(ControllerBase, "", params)];
                    case 2:
                        data = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        console.log(error_3);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, data];
                }
            });
        });
    };
    SizeGuideServices.PutSizeGuide = function (id, sizeGuide) {
        return __awaiter(this, void 0, void 0, function () {
            var data, params, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = {};
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        params = {
                            UserCred: __1.StorageServices.GetCookieUserCredentials(),
                            Content: sizeGuide,
                        };
                        return [4 /*yield*/, BaseServices_1.default.PutServices(ControllerBase, "".concat(id), params)];
                    case 2:
                        data = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        console.log(error_4);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, data];
                }
            });
        });
    };
    SizeGuideServices.DeleteSizeGuide = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var data, userCred, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = {};
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        userCred = __1.StorageServices.GetCookieUserCredentials();
                        return [4 /*yield*/, BaseServices_1.default.DelServices(ControllerBase, "".concat(id, "?userid=").concat(userCred.UserId, "&platformid=").concat(userCred.PlatformId))];
                    case 2:
                        data = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _a.sent();
                        console.log(error_5);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, data];
                }
            });
        });
    };
    SizeGuideServices.GetSizesGuidesRelatedCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, userCred, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = {};
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        userCred = __1.StorageServices.GetCookieUserCredentials();
                        return [4 /*yield*/, BaseServices_1.default.GetServices(ControllerBase, "guides/codes?userid=".concat(userCred.UserId, "&platformid=").concat(userCred.PlatformId))];
                    case 2:
                        data = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_6 = _a.sent();
                        console.log(error_6);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, data];
                }
            });
        });
    };
    return SizeGuideServices;
}());
exports.default = SizeGuideServices;
//# sourceMappingURL=SizeGuideServices.js.map